import { CheckButton } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface ICCAAgreementCheckBox {
    disabled?: boolean;
    onChange: () => void;
}

export const ICCAAgreementCheckBox: React.FC<ICCAAgreementCheckBox> = ({ disabled = false, onChange }) => {
    const isMobile = isMobileScreen();
    const labelChecked = 'I agree to the ICCA agreement';
    const labelUnchecked = 'Review and agree to ICCA agreement';
    const value = useBrokerNewReferralStore((s) => s.referral.iccaAgreement);

    const handleToggle = () => {
        if (onChange) {
            onChange();
        }
    };

    return (
        <>
            <CheckButton
                id='iccaAgreementCheckBox'
                label={value ? labelChecked : labelUnchecked}
                selected={value}
                onToggle={() => handleToggle()}
                width={isMobile ? '100%' : '300px'}
                disabled={disabled}
                hideCheckbox={!value}
            />
        </>
    );
};
